import { bigNumbersFiltersInitialFormValues } from '../components/BigNumbersFilters/Schema/initialFormValues'
import { consolidatedPreviewFiltersInitialFormValues } from '../components/DetailedPreviewFilters/schema/initialFormValues'
import type { PreviewFormProps } from './types'

export const initialFormValues: PreviewFormProps = {
  bigNumbersFilters: bigNumbersFiltersInitialFormValues,
  consolidatedPreviewFilters: consolidatedPreviewFiltersInitialFormValues
}
